// Pro API - Project Operations
import { request } from "../base";
import type { Project } from "./types";

export const projectsApi = {
	async list(
		proId: string,
		params?: Record<string, string>,
		options?: { includePhotoCount?: boolean },
	) {
		const merged: Record<string, string> = { ...(params ?? {}) };
		// Server hard-caps page size at 100 and defaults to 20. Portal list views
		// filter client-side and need the full set, so request the max by default.
		// Larger portfolios (>100) would need real pagination.
		merged.limit ??= "100";
		if (options?.includePhotoCount) {
			merged.includePhotoCount = "1";
		}
		const query =
			Object.keys(merged).length > 0
				? `?${new URLSearchParams(merged).toString()}`
				: "";
		return request<Project[]>(`/api/pro/${proId}/projects${query}`);
	},

	async get(proId: string, projectId: string) {
		return request<Project & { photos: unknown[] }>(
			`/api/pro/${proId}/projects/${projectId}`,
		);
	},

	async create(proId: string, data: Partial<Project>) {
		return request<Project>(`/api/pro/${proId}/projects`, {
			method: "POST",
			body: data,
		});
	},

	async update(proId: string, projectId: string, data: Partial<Project>) {
		return request<Project>(`/api/pro/${proId}/projects/${projectId}`, {
			method: "PUT",
			body: data,
		});
	},

	async delete(proId: string, projectId: string) {
		return request(`/api/pro/${proId}/projects/${projectId}`, {
			method: "DELETE",
		});
	},

	async publish(proId: string, projectId: string) {
		return request<Project>(
			`/api/pro/${proId}/projects/${projectId}/publish`,
			{
				method: "POST",
			},
		);
	},

	async archive(proId: string, projectId: string) {
		return request<Project>(
			`/api/pro/${proId}/projects/${projectId}/archive`,
			{
				method: "POST",
			},
		);
	},

	async unarchive(proId: string, projectId: string) {
		return request<Project>(
			`/api/pro/${proId}/projects/${projectId}/unarchive`,
			{
				method: "POST",
			},
		);
	},
};
